import Icon from '../components/Icon.vue'

Icon.register({
  paw: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M256 224C176.6 224 64 346.8 64 424.3 64 459.1 90.8 480 135.7 480 184.6 480 216.8 454.9 256 454.9 295.5 454.9 327.9 480 376.3 480 421.2 480 448 459.1 448 424.3 448 346.8 335.4 224 256 224zM108.7 211.4C98.3 176.7 66.3 154.3 37.2 161.3 8 168.2-7.1 201.9 3.3 236.6 13.7 271.3 45.7 293.7 74.8 286.7 104 279.8 119.1 246 108.7 211.4zM193.4 190.6C224.4 182.5 239.9 140.7 228 97.3S181.5 25.2 150.6 33.4 104.1 83.3 116 126.7C127.8 170.2 162.5 198.8 193.4 190.6zM474.8 161.3C445.7 154.3 413.7 176.8 403.3 211.4 392.9 246.1 408 279.8 437.2 286.7 466.3 293.7 498.3 271.3 508.7 236.6 519.1 202 503.9 168.2 474.8 161.3zM318.6 190.6C349.5 198.8 384.2 170.2 396 126.7 407.9 83.3 392.4 41.5 361.4 33.4S295.8 53.8 284 97.3C272.1 140.7 287.6 182.5 318.6 190.6z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/paw.js
// module id = 7bVk
// module chunks = 144